//thurd-party
import { useContext, useEffect, useRef, useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import "react-quill/dist/quill.core.css";
//custom modules
import Menu from "./Menu";
import ThemeControl from "../CommonComponents/ThemeControl/ThemeControl";
import { getContent, getContentMenu, getLinks } from "./CommonFunc";
import Content from "./Content";
import ArticleCreater from "./ArticleCreater";
import { EDITOR_MODE } from "./Constans";
import DeleteArticle from "./DeleteDialog";
import ErrorDialog from "./ErrorDialog";
import ChildrenMenu from "./ChildrenMenu";
import SiteMap from "./SiteMap";
import BackButton from "../CommonComponents/BackButton/BackButton";
import { AppContext } from "../Context/AppContext";
import { useQuery } from "./effects";
//svgs
import ArrowUp from "../Icons/ArrowUp";
import ArrowDown from "../Icons/ArrowDown";
import Pencil from "../Icons/Pencil";
import EyeIcon from "../Icons/Eye";
//styles
import "./Site.scss";

console.log(process.env.NODE_ENV);

//component context
export const SiteLayoutContext = createContext();

function SiteLayout(props) {
	//contexts
	const { theme } = useContext(AppContext);

	//states
	const [content, setContent] = useState([]);
	const [currentContentId, setCurrentContentId] = useState(undefined);
	const [currentEditableContentId, setCurrentEditableContentId] =
		useState(undefined);
	const [contentMenu, setContentMenu] = useState([]);
	const [currentSublings, setCurrentSublings] = useState([]);
	const [openEditor, setOpenEditor] = useState({
		open: false,
		mode: EDITOR_MODE.create,
	});
	const [openMap, setOpenMap] = useState(false);
	const [deleteDialog, deleteDialogVisible] = useState({ open: false });
	const [isAdmin, setIsAdmin] = useState(false);
	const [errorDialog, setErrorDialog] = useState({
		open: false,
		message: "",
	});
	const [links, setLinks] = useState([]);

	//hooks
	const navigate = useNavigate();
	const query = useQuery();

	//refs
	const contentRef = useRef();
	const sublingsListRef = useRef();

	//variables
	const currentContentObject =
		contentMenu.find((e) => e.ID === currentContentId) ?? {};
	const contentSublingsArray = contentMenu.filter(
		(menyItem) => menyItem.ID_PAR === currentContentObject.ID_PAR
	);
	const currentContentPositionInSublings = contentSublingsArray.findIndex(
		(menuItem) => menuItem.ID === currentContentId
	);
	const arrayAfterCurrentElement = contentSublingsArray.slice(
		currentContentPositionInSublings
	);
	const arrayBeforeCurrentElement = contentSublingsArray.slice(
		0,
		currentContentPositionInSublings
	);
	console.log("after", arrayAfterCurrentElement);
	console.log("before", arrayBeforeCurrentElement);
	// arrayBeforeCurrentElement.pop();
	const processingContentSublingArray = arrayAfterCurrentElement.concat(
		arrayBeforeCurrentElement
	);

	//#region functions
	const goToArticle = async (id) => {
		await getContent(id).then((result) => {
			setContent(result);
			setCurrentContentId(id);
			navigate(`/site?id=${id}`);
		});
	};
	const updateMenuAndContent = async (loadingId = undefined) => {
		if (loadingId !== undefined) {
			await goToArticle(loadingId);
		}
		const result = await getContentMenu();
		console.log(result);
		setContentMenu(result);
		const content = await getContent(query.get("id") ?? result[0]?.ID);
		setContent(content);
		if (query.get("id")) {
			setCurrentContentId(query.get("id"));
		} else {
			setCurrentContentId(content[0]?.ID);
		}
		if (loadingId !== undefined) {
			setOpenEditor((prev) => ({ open: false }));
			deleteDialogVisible((prev) => ({ open: false }));
		}
	};

	const fillLinks = () => {
		getLinks(currentContentId).then((result) => {
			console.log(result);
			setLinks(result || []);
		});
	};
	const refresh = (id) =>
		getContent(id).then((content) => {
			setContent(content);
		});

	const carousel = (direction) => {
		const currentArticleId = currentSublings.findIndex(
			(e) => e.ID === currentContentId
		);
		let resultIndex = 0;
		if (direction === -1) {
			resultIndex = currentArticleId - 1;
			if (resultIndex < 0) {
				resultIndex = currentSublings.length - 1;
			}
		} else {
			resultIndex = currentArticleId + 1;
			if (resultIndex === currentSublings.length) {
				resultIndex = 0;
			}
		}
		goToArticle(currentSublings[resultIndex].ID);
		sublingsListRef.current.scrollTo(0, 0);
	};
	//#endregion

	//#region effects
	useEffect(() => {
		if (openEditor.open) {
			return;
		}
		updateMenuAndContent(openEditor.createdArticleId);
	}, [openEditor]);

	useEffect(() => {
		if (deleteDialog.open) {
			return;
		}
		updateMenuAndContent(deleteDialog.parentId);
	}, [deleteDialog]);

	useEffect(() => {
		if (currentContentId !== undefined) {
			setOpenMap(false);
			fillLinks();
		}
	}, [currentContentId]);

	useEffect(() => {
		if (isAdmin === false) {
			setCurrentEditableContentId(undefined);
		}
	}, [isAdmin]);

	useEffect(() => {
		if (currentContentId === undefined) {
			return;
		}
		const result = contentMenu.filter(
			(e) =>
				e?.ID_PAR === contentMenu.find((u) => u.ID === currentContentId)?.ID_PAR
		);
		console.log(result);
		setCurrentSublings(result);
	}, [currentContentId]);

	useEffect(() => {
		if (contentRef.current) {
			contentRef.current.scrollTo(0, 0);
		}
	}, [content]);
	//#endregion

	return (
		<>
			<SiteLayoutContext.Provider value={{ setIsAdmin }}>
				{openEditor.open ? (
					<ArticleCreater
						setOpenEditor={setOpenEditor}
						color={theme.color}
						style={{
							fontSize: `${(18 / theme.scaleFactor) * theme.fontMultiplier}px`,
						}}
						content={content}
						currentContentId={currentContentId}
						mode={openEditor.mode}
						setErrorDialog={setErrorDialog}
						links={content.filter((e) => e.IS_SELECTED)}
					/>
				) : (
					<div
						className='main-container'
						data-type='site'
						color={theme.color}
						style={{
							fontSize: `${(16 / theme.scaleFactor) * theme.fontMultiplier}px`,
						}}
					>
						<div
							className='head'
							style={{
								fontSize: `${
									(16 / theme.scaleFactor) * theme.headerFontMultiplier
								}px`,
							}}
						>
							<div className='navigation-header'>
								<BackButton />
								<div
									className={`site-map-button ${
										openMap ? "site-map-active" : ""
									}`}
									onClick={() => setOpenMap((prev) => !prev)}
								>
									Карта сайта
								</div>
							</div>
							<div className='content-header'></div>
							<div className='support-header'>
								<ThemeControl />
								{/* <Toggle
								leftText={""}
								rigthText={"Режим администратора"}
								func={() => setIsAdmin((prev) => !prev)}
								checked={isAdmin}
							/> */}
								<Pencil
									// width={36 / theme.scaleFactor}
									// height={36 / theme.scaleFactor}
									width={2}
									height={2}
									func={() => setIsAdmin(true)}
									className={`admin-toggle ${
										isAdmin ? "admin-toggle-active" : ""
									}`}
								/>
								<EyeIcon
									// width={48 / theme.scaleFactor}
									// height={48 / theme.scaleFactor}
									width={3}
									height={3}
									func={() => setIsAdmin(false)}
									className={`eye-toggle ${
										!isAdmin ? "eye-toggle-active" : ""
									}`}
								/>
							</div>
						</div>
						{openMap ? (
							<div className='body'>
								<SiteMap
									isAdmin={isAdmin}
									currentEditableContentId={currentEditableContentId}
									contentMenu={contentMenu}
									setContentMenu={setContentMenu}
								>
									<Menu
										content={contentMenu}
										currentContentId={currentContentId}
										setCurrentContentId={setCurrentContentId}
										goToArticle={goToArticle}
										setOpenEditor={setOpenEditor}
										setContentMenu={setContentMenu}
										mapMode={true}
										setCurrentEditableContentId={
											isAdmin ? setCurrentEditableContentId : undefined
										}
										currentEditableContentId={
											isAdmin ? currentEditableContentId : undefined
										}
										isAdmin={isAdmin}
									/>
								</SiteMap>
							</div>
						) : (
							<div className='body'>
								<div
									className='navigation-column'
									style={{
										fontSize: `${
											(16 / theme.scaleFactor) * theme.bodyLeftFontMultiplier
										}px`,
									}}
								>
									<ul
										className='navigation'
										// style={{
										// 	height: `calc(100vh - ${100 / theme.scaleFactor}px)`,
										// }}
									>
										<BreadCrumps
											contentMenu={contentMenu}
											currentContentId={currentContentId}
											setCurrentContentId={setCurrentContentId}
											goToArticle={goToArticle}
										/>
										<div className='navigation-content-header'>
											{currentContentObject?.HEADER || (
												<div>Статья не выбрана</div>
											)}
										</div>
										<ChildrenMenu
											content={contentMenu}
											currentContentId={currentContentId}
											setCurrentContentId={setCurrentContentId}
											goToArticle={goToArticle}
										/>
									</ul>
								</div>
								<div
									className='content-column'
									style={{
										fontSize: `${
											(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
										}px`,
										minHeight: `calc(100vh - 5em)`,
									}}
								>
									<div ref={contentRef} className='content'>
										<Content
											content={content}
											contentMenu={contentMenu}
											currentContentId={currentContentId}
											setContent={setContent}
											links={links}
											fillLinks={fillLinks}
											refresh={refresh}
										/>
									</div>
								</div>
								<div
									className='support-column'
									style={{
										fontSize: `${
											(16 / theme.scaleFactor) * theme.bodyRightFontMultiplier
										}px`,
										flex: `0 0 ${300 / theme.scaleFactor}px`,
									}}
								>
									<>
										<div className='navigation-arrows' data-admin={isAdmin}>
											<ArrowUp
												width={1}
												height={1}
												className='navigation-arrow back'
												onClick={() => carousel(-1)}
											/>
											{/* <div>↑</div> */}
											<ArrowDown
												width={1}
												height={1}
												className='navigation-arrow forward'
												onClick={() => carousel(1)}
											/>
										</div>
										{!isAdmin ? (
											<div ref={sublingsListRef} className='sublings-list'>
												{processingContentSublingArray.map((contentSubling) => (
													<div
														className='list-item'
														data-current={
															contentSubling.ID === currentContentId
														}
														style={{
															fontSize:
																contentSubling.ID === currentContentId
																	? `${
																			(20 / theme.scaleFactor) *
																			theme.bodyRightFontMultiplier
																	  }px`
																	: `${
																			(16 / theme.scaleFactor) *
																			theme.bodyRightFontMultiplier
																	  }px`,
														}}
														onClick={() => {
															goToArticle(contentSubling.ID);
														}}
													>
														{contentSubling.HEADER}
													</div>
												))}
											</div>
										) : null}
									</>
									{isAdmin ? (
										<div className='support'>
											<div
												className='button'
												onClick={() =>
													setOpenEditor((prev) => ({
														open: true,
														mode: EDITOR_MODE.create,
													}))
												}
											>
												Добавить статью
											</div>
											<div
												className='button'
												onClick={() =>
													setOpenEditor((prev) => ({
														open: true,
														mode: EDITOR_MODE.edit,
													}))
												}
											>
												Редактировать статью
											</div>
											<div
												className='button delete'
												onClick={() => deleteDialogVisible({ open: true })}
											>
												Удалить статью
											</div>
											{/* <SelectedArticlesList
											selectedArticles={content.filter((e) => e.IS_SELECTED)}
											currentContentId={currentContentId}
											fillLinks={fillLinks}
											refresh={refresh}
										/> */}
										</div>
									) : null}
								</div>
							</div>
						)}
						{/* <div className='footer'>
						<div className='navigation-footer'></div>
						<div className='content-footer'></div>
						<div className='support-footer'></div>
					</div> */}
					</div>
				)}
				{deleteDialog.open ? (
					<DeleteArticle
						theme={theme}
						content={content}
						currentContentId={currentContentId}
						deleteDialogVisible={deleteDialogVisible}
					/>
				) : null}
				{errorDialog.open ? (
					<ErrorDialog
						theme={theme}
						setErrorDialog={setErrorDialog}
						errorDialog={errorDialog}
					/>
				) : null}
			</SiteLayoutContext.Provider>
		</>
	);
}

const BreadCrumps = ({ contentMenu, currentContentId, goToArticle }) => {
	const [array, setArray] = useState([]);
	useEffect(() => {
		const path = createPath();
		const domPath = visualizePath(path);
		setArray(domPath);
	}, [currentContentId]);
	const visualizePath = (path) => {
		return path.map((item, i) => (
			<div className='path-item'>
				<div
					className={`item ${item.ID === currentContentId ? "active" : ""}`}
					// style={{ paddingLeft: `${i * 24 + 10}px` }}
					onClick={() => {
						goToArticle(item.ID);
					}}
				>
					{/* {i === 0 ? null : <ArrowInner widht={24} height={24} />} */}
					{item.HEADER}
				</div>
			</div>
		));
	};
	const createPath = () => {
		if (currentContentId === undefined) {
			return [];
		}
		let result = [];
		let element = contentMenu.find((e) => e.ID === currentContentId);
		let parentId = element?.ID_PAR;
		while (parentId !== undefined) {
			result.push(element);
			element = contentMenu.find((e) => e.ID === parentId);
			parentId = element?.ID_PAR;
		}
		result.shift();
		return result.reverse();
	};
	return (
		<>
			{array.length !== 0 ? <div className='breadCrumps'>{array}</div> : null}
		</>
	);
};

export default SiteLayout;
